import { Stack, Typography, useTheme } from "@mui/material";

const TitleBar = ({ title }: { title: string }) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        background: theme.palette.background.layout,
        width: "100%",
        py: 5,
        px: 2,
      }}
    >
      <Typography variant="h3" align="center">
        {title}
      </Typography>
    </Stack>
  );
};

export default TitleBar;
